const painPoints = [
  {
    icon: "ri-emotion-unhappy-line",
    text: "なんとなく体が重く、\nやる気が出ない",
  },
  {
    icon: "ri-zzz-line",
    text: "睡眠をとっても、\n疲れが抜けない",
  },
  {
    icon: "ri-heart-pulse-line",
    text: "肩こりや腰痛が\n慢性的に続いている",
  },
  {
    icon: "ri-mental-health-line",
    text: "仕事やプライベートで\nストレスが溜まっている",
  },
  {
    icon: "ri-time-line",
    text: "自分のための時間が\nとれていない",
  },
  {
    icon: "ri-leaf-line",
    text: "自然の中でゆっくり\n過ごしたい",
  },
];

export default function PainPoints() {
  return (
    <section className="py-24 bg-[#faf8f2]">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#3a4a28]/50 text-xs tracking-[0.4em] mb-4">SYMPTOM</p>
          <h2 className="font-serif text-3xl md:text-4xl text-[#2a2a1e] leading-tight">
            こんな感覚、<br />覚えがありませんか。
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {painPoints.map((item, i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-8 flex flex-col items-start gap-4 border border-[#e8e4d8]"
            >
              <div className="w-10 h-10 flex items-center justify-center text-[#3a4a28]">
                <i className={`${item.icon} text-2xl`} />
              </div>
              <p className="text-[#3a3a2a] text-sm leading-relaxed whitespace-pre-line tracking-wide">
                {item.text}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-[#3a4a28]/8 rounded-lg p-8 border border-[#3a4a28]/15">
          <p className="text-[#3a4a28] text-sm leading-loose text-center tracking-wide">
            その不調、KUUで根本から整えませんか。<br />
            身体の状態に合わせて、動ける身体へ戻るためのケアをご提案します。
          </p>
        </div>
      </div>
    </section>
  );
}
